export const getPermissions = () => {
    const permission = localStorage.getItem('permission');
    if (!permission) return {};
    try {
        return JSON.parse(permission);
    } catch (e) {
        console.error('Error parsing permissions:', e);
        return {};
    }
};

// Enhanced permission checking for array-based permissions
export const hasPermission = (resource, action) => {
    if (!resource || !action) return false;
    
    // Admin users have full access - bypass all permission checks
    if (isAdmin()) {
        return true;
    }
    
    const permissions = getPermissions();
    
    // Handle array-based permissions (from subadmin)
    if (Array.isArray(permissions)) {
        const module = permissions.find(perm => perm.module === resource);
        return module ? Boolean(module[action]) : false;
    }
    
    // Handle object-based permissions (fallback)
    return Boolean(permissions?.[resource]?.[action]);
};

// Check if user can write to a specific resource
export const canWrite = (resource) => {
    // Admin users always have write access
    if (isAdmin()) {
        return true;
    }
    return hasPermission(resource, 'write');
};

// Check if user can read a specific resource
export const canRead = (resource) => {
    // Admin users always have read access
    if (isAdmin()) {
        return true;
    }
    return hasPermission(resource, 'read');
};

// Get permission level for display purposes
export const getPermissionLevel = (resource) => {
    // Admin users always have write access
    if (isAdmin()) {
        return 'admin';
    }
    
    const canWritePermission = canWrite(resource);
    const canReadPermission = canRead(resource);
    
    if (canWritePermission) return 'write';
    if (canReadPermission) return 'read';
    return 'none';
};

// Check if user is admin (has full access)
export const isAdmin = () => {
    const role = localStorage.getItem('role');
    return role === '"admin"' || role === 'admin';
};
